import { SetupWizard, goToAdminSignIn } from '@matix/ui';
import { useLang } from '../../lib/language';
import { useCashierAuthStore } from '../../store/cashierAuthStore';

/**
 * A newly provisioned tenant's first sign-in on the till: the shared Initial
 * Setup Wizard. Finishing it opens the ADMIN app's sign-in, workspace filled in.
 */
export function SetupScreen(): JSX.Element | null {
  const state = useCashierAuthStore((s) => s.state);
  const exitSetup = useCashierAuthStore((s) => s.exitSetup);
  const { lang, setLang } = useLang();
  if (state.kind !== 'setup') return null;
  return (
    <SetupWizard
      tenantSlug={state.slug}
      tenantName={state.tenantName}
      setupToken={state.setupToken}
      lang={lang}
      onLangChange={setLang}
      apiBase={import.meta.env.VITE_API_BASE_URL ?? ''}
      continueLabel={{ en: 'Go to the admin dashboard', ar: 'الانتقال إلى لوحة الإدارة' }}
      // Setting a business up is admin work: finish in the admin app, not the till.
      onComplete={() => goToAdminSignIn(state.slug, import.meta.env.VITE_ADMIN_URL as string | undefined)}
      onExit={exitSetup}
    />
  );
}
